// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2oPxp","label":"LabeledBox_label__1Hgzd"};